import { AxiosRequestConfig, AxiosResponse } from 'axios';
import config from 'config';

import { parseDataByTag, ParsedDataByTag } from 'models/dataByTag';
import { parseGeoInfo } from 'models/geoInfo';
import { HttpClient, QueryOptions, GeoInfoDma } from './api-types';

const API_KEY = config.api.apiKey;
const API_URL = config.api.apiUrl;
const API_PATH = config.api.apiPath;
const GEO_API_URL = config.api.geoApiUrl;
const GEO_API_KEY = config.geoApiKey;

const VERSION_NUMBER = 'v1';

const queryApi = (
  httpClient: HttpClient,
  url: string,
  options?: QueryOptions,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: 'get',
    headers: { 'x-api-key': API_KEY },
  };

  if (options) {
    if (options.params) request.params = options.params;
  }

  return httpClient(request);
};

const queryGeoApi = (
  httpClient: HttpClient,
  url: string,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: 'get',
    headers: { 'x-api-key': GEO_API_KEY },
  };

  return httpClient(request);
};

const getApiUrl = (target: string, version: string): string => {
  return `${API_URL}${API_PATH}/content/${target}/${version}`;
};

export const fetchDataByTag = async (
  httpClient: HttpClient,
  tag: string,
): Promise<ParsedDataByTag> => {
  // let stations = [];
  let response: AxiosResponse | null = null;

  try {
    const geoApiResponse = await queryGeoApi(httpClient, GEO_API_URL);
    const { data: result } = geoApiResponse;
    const geoInfo: GeoInfoDma = parseGeoInfo(result);
    const stations = (geoInfo?.stations || []).join(',');

    response = await queryApi(httpClient, getApiUrl('by-tag', VERSION_NUMBER), {
      params: {
        tag,
        device: config.ksDeviceType,
        stations,
      },
    });
  } catch (e) {
    response = await queryApi(httpClient, getApiUrl('by-tag', VERSION_NUMBER), {
      params: {
        tag,
        device: config.ksDeviceType,
      },
    });
  }

  return parseDataByTag(response);
};
